type Props = {
    logo: string
  }
  
  export const BrandLogoCard = ({ logo }: Props) => {
    return (
      <div className="bg-white rounded-[16px] p-6 shadow-sm flex items-center justify-center w-[180px] h-[90px]">
  
        <img
          src={logo}
          alt="Brand logo"
          className="max-h-[50px] object-contain"
        />
  
      </div>
    )
  }